import { gql, useMutation } from '@apollo/client';

interface IDeleteRawFilesInput {
  studyId: string;
  ids: string[];
}

export interface ISkippedFile {
  id: string;
  name: string;
  reason: string;
}

export interface IDeleteRawFilesOutput {
  deletedCount: number;
  skippedCount: number;
  skippedFiles: ISkippedFile[];
}

interface IDeleteRawFilesResponse {
  deleteRawFiles: IDeleteRawFilesOutput;
}

const DELETE_RAW_FILES = gql`
  mutation deleteRawFiles($studyId: String!, $ids: [String!]!) {
    deleteRawFiles(studyId: $studyId, ids: $ids) {
      deletedCount
      skippedCount
      skippedFiles {
        id
        name
        reason
      }
    }
  }
`;

interface IOptions {
  onError: (apolloError) => void;
  onCompleted: (response: IDeleteRawFilesResponse) => void;
}

export default (options: IOptions) => {
  return useMutation<IDeleteRawFilesResponse, IDeleteRawFilesInput>(DELETE_RAW_FILES, options);
};
